import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { UzurvDirectivesModule } from '@uzurv/core';
import { RequiresPermissionsModule } from '../../directives';
import { GenericSearchSelectModule } from '../../generic-search-select';
import { CreateDispatcherDialogComponent } from './create-dispatcher-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    UzurvDirectivesModule,
    RequiresPermissionsModule,
    GenericSearchSelectModule
  ],
  exports: [CreateDispatcherDialogComponent],
  declarations: [CreateDispatcherDialogComponent]
})
export class CreateDispatcherDialogModule {}
